import { MAZE } from '../../constants/measure';
import * as apiActions from '../api/apiActions';

class MazeServiceClient {
    static NAME = 'maze';

    static MEASURES = [MAZE.MEASURE];

    static URL = '/maze-api/v1';

    static CLIENT_TO_SERVER_MEASURE_NAME = {
        maze: MAZE.NAME,
    };

    /**
    * Constructs request url to Maze service based on the passed config object.
    * config may include:
        - formId
        - grage
        - period
    */
    static constructFormEndpoint({ formId, grade, period }) {
        let endpoint = `${MazeServiceClient.URL}/forms`;

        if (formId) {
            return `${endpoint}/${formId}`;
        }

        const params = [];
        if (grade) {
            params.push(`grade=${grade}`);
        }
        if (period) {
            params.push(`period=${period}`);
        }
        if (params.length > 0) {
            endpoint += `?${params.join('&')}`;
        }

        return endpoint;
    }

    /**
     * Construct and return the URL API endpoint for a list of results
     */
    static constructResultListEndpoint({
        studentId, grade, period, schoolYear,
    } = {}) {
        let endpoint = `${MazeServiceClient.URL}/results`;
        const params = [
            'with_field_study=true',  // remove after Maze Fields Study is done
        ];
        if (studentId) {
            params.push(`student_uids=${studentId}`);
        }
        if (grade) {
            params.push(`grade_level=${grade}`);
        }
        if (period) {
            params.push(`period=${period}`);
        }
        if (schoolYear) {
            params.push(`school_year=${schoolYear}`);
        }
        if (params.length > 0) {
            endpoint += `?${params.join('&')}`;
        }
        return endpoint;
    }

    /**
     * Construct and return the URL API endpoint for a given resultId
     * @param {str} resultId
     */
    static constructResultEndpoint(resultId) {
        return `${MazeServiceClient.URL}/results/${resultId}`;
    }

    /**
     * Construct save Maze online result endpoint
     */
    static constructSaveResultEnpoint() {
        return `${MazeServiceClient.URL}/online_result`;
    }

    /**
     * Sends GET request to endpoint with provided parameters
     * @param {str} grade - (optional) student's grade
     * @param {str} period - (optional) BOY | MOY | EOY | SUMMER (Maze only)
     * @param {str} formId - (optional) assessment form ID
     * @returns {JSON} server response
     */
    static getForm = (grade, period, formId, retryActionName) => (dispatch) => {
        const config = {
            grade,
            period,
            formId,
        };

        const endpoint = MazeServiceClient.constructFormEndpoint(config);
        return dispatch(apiActions.makeCacheableRetriableGetContentRequest(endpoint, retryActionName));
    };
}

export default MazeServiceClient;
